/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var firebase = require('./app');
require('./auth');
var Storage, XMLHttpRequest;

require('./database');
require('./storage');
var AsyncStorage;

require('./messaging');
exports.default = firebase;
module.exports = exports['default'];
//# sourceMappingURL=firebase.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/firebase-browser.js
// module id = 446
// module chunks = 0